/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { boolean as codecBoolean, number as codecNumber, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { Assignment } from './Assignment';
import { PlagiarismRunPlagiarismAssignmentAsJSON } from './PlagiarismRunPlagiarismAssignmentAsJSON';
import { PlagiarismRunPlagiarismCourseAsJSON } from './PlagiarismRunPlagiarismCourseAsJSON';
import { PlagiarismState } from './PlagiarismState';
const PlagiarismRunParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['state', PlagiarismState],
    [
        'submissionsDone',
        /* #__PURE__ */ parsers.maybeNull(codecNumber),
        'submissions_done',
    ],
    [
        'submissionsTotal',
        /* #__PURE__ */ parsers.maybeNull(codecNumber),
        'submissions_total',
    ],
    ['providerName', codecString, 'provider_name'],
    ['config', codec.unknown],
    ['createdAt', parsers.moment, 'created_at'],
    ['assignment', Assignment],
    ['log', /* #__PURE__ */ parsers.maybeNull(codecString)],
    [
        'assignments',
        /* #__PURE__ */ codec.record(codecString, PlagiarismRunPlagiarismAssignmentAsJSON),
    ],
    [
        'courses',
        /* #__PURE__ */ codec.record(codecString, PlagiarismRunPlagiarismCourseAsJSON),
    ],
    ['casesDropped', codecBoolean, 'cases_dropped'],
]));
export class PlagiarismRun extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PlagiarismRunParser.decode(input).map(res => new PlagiarismRun(res));
    }
    static unsafeDecode(input) {
        return PlagiarismRun.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PlagiarismRunParser.encode(data);
    }
    static schema() {
        return PlagiarismRunParser.schema();
    }
}
